import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const styles = (theme: Theme) => {

	return createStyles({
		formStatusMessageBox_statusCollapse: {
			zIndex: theme.zIndex.mobileStepper,	
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				margin: theme.spacing(0),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 3),
				margin: theme.spacing(1.5, 0, 0 , 0),
			},
		},
		formStatusMessageBox_statusCollapseSticky: {
			position: 'sticky',
			top: 0,
		},
		formStatusMessageBox_statusWrapper: {
			display: 'flex',
		},
		formStatusMessageBox_statusWrapperPrimary: {
			background: theme.palette.primary.main,
		},
		formStatusMessageBox_statusWrapperSecondary: {
			background: theme.palette.secondary.main,
		},
		formStatusMessageBox_statusWrapperWarning: {
			background: theme.palette.warning.main,
		},
		formStatusMessageBox_statusWrapperError: {
			background: theme.palette.error.main,
		},
		formStatusMessageBox_statusWrapperSuccess: {
			background: theme.palette.success.main,
		},
		formStatusMessageBox_statusWrapperInfo: {
			background: theme.palette.info.main,
		},
		formStatusMessageBox_statusIconWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			padding: theme.spacing(1.5, 1.5),
		},
		formStatusMessageBox_statusIconWrapperPrimary: {
			background: theme.palette.primary[800],
		},
		formStatusMessageBox_statusIconWrapperSecondary: {
			background: theme.palette.secondary[800],
		},
		formStatusMessageBox_statusIconWrapperWarning: {
			background: theme.palette.warning[600],
		},
		formStatusMessageBox_statusIconWrapperError: {
			background: theme.palette.error[800],
		},
		formStatusMessageBox_statusIconWrapperSuccess: {
			background: theme.palette.success[800],
		},
		formStatusMessageBox_statusIconWrapperInfo: {
			background: theme.palette.info[600],
		},
		formStatusMessageBox_statusIconPrimary: {
			color: theme.palette.primary.contrastText,
		},
		formStatusMessageBox_statusIconSecondary: {
			color: theme.palette.secondary.contrastText,
		},
		formStatusMessageBox_statusIconWarning: {
			color: theme.palette.warning.contrastText,
		},
		formStatusMessageBox_statusIconError: {
			color: theme.palette.error.contrastText,
		},
		formStatusMessageBox_statusIconSuccess: {
			color: theme.palette.success.contrastText,
		},
		formStatusMessageBox_statusIconInfo: {
			color: theme.palette.info.contrastText,
		},
		formStatusMessageBox_statusLabelWrapper: {
			display: 'flex',
			justifyContent: 'space-between',
			width: '100%',
		},
		formStatusMessageBox_statusLabel: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			padding: theme.spacing(1.5, 1.5),
		},
		formStatusMessageBox_statusLabelPrimary: {
			color: theme.palette.primary.contrastText,
		},
		formStatusMessageBox_statusLabelSecondary: {
			color: theme.palette.secondary.contrastText,
		},
		formStatusMessageBox_statusLabelWarning: {
			color: theme.palette.warning.contrastText,
		},
		formStatusMessageBox_statusLabelError: {
			color: theme.palette.error.contrastText,
		},
		formStatusMessageBox_statusLabelSuccess: {
			color: theme.palette.success.contrastText,
		},
		formStatusMessageBox_statusLabelInfo: {
			color: theme.palette.info.contrastText,
		},
		formStatusMessageBox_statusCloseIconWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		formStatusMessageBox_statusCloseIconPrimary: {
			color: theme.palette.error.contrastText,
		},
		formStatusMessageBox_statusCloseIconSecondary: {
			color: theme.palette.error.contrastText,
		},
		formStatusMessageBox_statusCloseIconWarning: {
			color: theme.palette.error.contrastText,
		},
		formStatusMessageBox_statusCloseIconError: {
			color: theme.palette.error.contrastText,
		},
		formStatusMessageBox_statusCloseIconSuccess: {
			color: theme.palette.error.contrastText,
		},
		formStatusMessageBox_statusCloseIconInfo: {
			color: theme.palette.error.contrastText,
		},
	});
}

export default styles;
